import { render, staticRenderFns } from "./ReplaceShippingLeadTimeEventsDialog.vue?vue&type=template&id=4853dfd6&scoped=true&"
import script from "./ReplaceShippingLeadTimeEventsDialog.vue?vue&type=script&lang=js&"
export * from "./ReplaceShippingLeadTimeEventsDialog.vue?vue&type=script&lang=js&"
import style0 from "./ReplaceShippingLeadTimeEventsDialog.vue?vue&type=style&index=0&id=4853dfd6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4853dfd6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VContainer,VDialog})
